import { audiencesUrl } from 'src/configs/api'

// Audience tag vocabulary comes from CDP (cdp_tag_def), the same store the
// audience listing and segment rules resolve tags against. Returns plain tag
// names, alphabetically, enabled tags only.
export const fetchAudienceTags = async (api, search = '') => {
  const params = search ? { search } : {}
  const response = await api.get(`${audiencesUrl}/tags`, { params })
  return response?.data?.tags ?? []
}
